import { GET_ALL_PAYMENT_FAILURE, GET_ALL_PAYMENT_REQUEST, GET_ALL_PAYMENT_SUCCESS, VENDOR_TRANSFER_PAYMENT_FAILURE, VENDOR_TRANSFER_PAYMENT_REQUEST, VENDOR_TRANSFER_PAYMENT_SUCCESS } from "./ActionType";

const initialState = {
  payments: [],
  payment: null,
  loading: false,
  error: "",
};

export const adminPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_ALL_PAYMENT_REQUEST:
      case VENDOR_TRANSFER_PAYMENT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PAYMENT_SUCCESS:
      return { ...state, payments: action.payload , loading: false, error: ""};

      case VENDOR_TRANSFER_PAYMENT_SUCCESS:
      return { ...state, payment: action.payload , loading: false, error: ""};

    case GET_ALL_PAYMENT_FAILURE:
  case VENDOR_TRANSFER_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};